import { Link } from 'react-router-dom'

function Html() {
  return (
    <div>
      <footer className="px-4 lg:px-16  py-6 lg:py-16">
        <div className="">
          <div className="grid grid-cols-12 gap-4 xl:gap-10">
            <div className="col-span-12 md:col-span-12 lg:col-span-3 ">
              <div className="flex flex-col gap-2">
                <h3 className="text-xl font-bold mb-4">
                  <img src="/assets/img/ed/logopng.png" className='h-20' />
                  <div className='flex gap-4 mt-3'>
                    <div onClick={e => { window.open("https://www.youtube.com/@Frumme2ucard", "_blank") }} className="bg-gray-200 p-3 shadow-sm hover:bg-gray-300 hover:shadow-lg  cursor-pointer rounded-full flex items-center justify-center shrink-0">
                      <img src="/assets/img/youtube.svg" alt="youtube_icon" className="w-[22px]" />
                    </div>
                    <div onClick={e => { window.open("https://www.instagram.com/frum_me2u/?hl=en", "_blank") }} className="bg-gray-200 p-3 shadow-sm hover:bg-gray-300 hover:shadow-lg cursor-pointer rounded-full flex items-center justify-center shrink-0">
                      <img src="/assets/img/instagram.svg" alt="instagram_icon" className="w-[22px]" />
                    </div>
                    <div onClick={e => { window.open("https://www.facebook.com/profile.php?id=61579483935100", "_blank") }} className="bg-gray-200 p-3 shadow-sm hover:bg-gray-300 hover:shadow-lg cursor-pointer rounded-full flex items-center justify-center shrink-0">
                      <img src="/assets/img/Facebook.svg" alt="facebook_icon" className="w-[22px]" />
                    </div>
                  </div>
                </h3>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-4 lg:col-span-3">
              <h3 className="text-xl font-bold mb-5 worksans">About</h3>
              <ul className='flex flex-col gap-4'>
                <li>
                  <Link to="/blogs" className="hover:underline text-sm">News & Blogs</Link>
                </li>
                <li>
                  <Link to="/contactus" className="hover:underline text-sm">Help & Supports</Link>
                </li>
                <li>
                  <Link to="/faq" className="hover:underline text-sm">FAQ</Link>
                </li>
              </ul>
            </div>
            <div className="col-span-12 sm:col-span-4 lg:col-span-3">
              <h3 className="text-xl font-bold mb-4">Company</h3>
              <ul className='flex flex-col gap-4'>
                <li>
                  <Link to="/terms" className="hover:underline text-sm">Terms of service</Link>
                </li>
                <li>
                  <Link to="/aboutus" className="hover:underline text-sm">About us</Link>
                </li><li>
                  <Link to="/privacy" className="hover:underline text-sm">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/sms-policy" className="hover:underline text-sm">SMS Policy</Link>
                </li>
                <li>
                  <Link to="/contactus" className="hover:underline text-sm">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="col-span-12 sm:col-span-4 lg:col-span-3">
              <h3 className="text-xl font-bold mb-4">Contact Us</h3>
              <ul className='flex flex-col gap-4'>
                {/* <li>CNBS 1st Block 1st Cross, New York, US.</li>
                <li>+1 202-918-2132</li> */}
                <li>frumme2ucard@gmail.com</li>
                <li><Link to={"https://frumme2u.com/"} target="_blank" className="hover:underline hover:text-blue-600">https://frumme2u.com</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Html